<template>
  <div id="admin-component" class="container">
    <div class="nav-wrapper">
      <ul class="nav nav-pills nav-fill flex-column flex-md-row" id="tabs-icons-text" role="tablist">
        <li class="nav-item">
            <div :class = "{active: current_state=='counselors'}" @click="set_counselor('counselors')" class="nav-link mb-sm-3 mb-md-0" role="tab" aria-controls="tabs-icons-text-1"></i>Cố vấn</div>
        </li>
        <li class="nav-item">
            <div @click="set_counselor('appointment')"class="nav-link mb-sm-3 mb-md-0" :class = "{active: current_state=='appointment'}" role="tab" aria-controls="tabs-icons-text-1"></i>Lịch hẹn</div>
        </li>
        <li class="nav-item">
            <div @click="set_counselor('review')" class="nav-link mb-sm-3 mb-md-0" :class = "{active: current_state=='review'}" role="tab" aria-controls="tabs-icons-text-1"></i>Nhận xét & Đánh giá</div>
        </li>
        <li class="nav-item">
            <div @click="set_counselor('contacts')" :class = "{active: current_state=='contacts'}" class="nav-link mb-sm-3 mb-md-0" role="tab" aria-controls="tabs-icons-text-1"></i>Khách hàng liên hệ</div>
        </li>
        <li class="nav-item">
            <div @click="set_counselor('blog')" :class = "{active: current_state=='blog'}" class="nav-link mb-sm-3 mb-md-0" role="tab" aria-controls="tabs-icons-text-1"></i>Blog</div>
        </li>
      </ul>
    </div>
    <list-counselor v-if="current_state == 'counselors'"></list-counselor>
    <list-contacts v-if="current_state == 'contacts'"></list-contacts>
    <list-review v-if="current_state == 'review'"></list-review>
    <!-- <list-scholarship v-if="current_state == 'scholarships'"></list-scholarship> -->
    <list-appointment v-if="current_state == 'appointment'"></list-appointment>   
    <list-blog v-if="current_state == 'blog'"></list-blog>
  </div>

</template>
<script>  
  import ListCounselor from "./components/Admin/ListCounselor";
  import ListScholarship from "./components/Admin/ListScholarship"
  import ListAppointment from "./components/Admin/ListAppointment"
  import {mapState, mapActions, mapGetter} from 'vuex';
  import ListContacts from "./components/Admin/ListContacts"
  import ListReview from "./components/Admin/ListReview"
  import ListBlog from "./components/Admin/ListBlog"
  export default {
    components: {
      ListCounselor,
      ListScholarship,
      ListAppointment,
      ListContacts,
      ListReview,
      ListBlog,
    },    
    data: function(){
      return {
        current_state: 'counselors'
      }
    },
    methods: {
      set_counselor: function(state){
        this.current_state = state
      }
    },
    created: function(){      
      this.$store.dispatch('vuex_admin/list_counselors', {page: 1, keyword: ''})
    },
    computed: {
      ...mapState('vuex_admin',[
        'list-counselors',        
      ]),
    },
  };
</script>
<style lang="scss" scoped>
  @import "./components/Admin/admin.scss";  
</style>


// WEBPACK FOOTER //
// src/views/Admin.vue